
import { computed, ref, toRaw } from 'vue'
import UploadSong from './UploadSong.vue'
import { ColorList } from './config'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

export default {
  components: {
    UploadSong,
    MinusCircleOutlined,
    PlusOutlined
  },
  emits: ['onOk', 'onEditOk', 'cancel'],
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isEdit: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    const visibleComputed = computed(() => props.visible)
    const isEditComputed = computed(() => props.isEdit)

    const current = ref(props.value)

    const labelCol = { span: 5 }
    const wrapperCol = { span: 17 }

    const formRef = ref()

    const handleSelectSongOk = info => {
      current.value = { ...toRaw(current.value), ...info }
    }

    const handleDelete = item => {
      const index = current.value.para_info.indexOf(item)
      const oldCurrent = ref({ ...toRaw(current.value) })
      const list = [...toRaw(oldCurrent.value.para_info)]
      list.splice(index, 1)
      oldCurrent.value.para_info = list
      current.value = oldCurrent.value
    }

    const handleAddParaInfo = () => {
      if (!current.value.para_info) {
        current.value.para_info = []
      }
      current.value.para_info.push({})
    }

    const handleCancel = () => {
      emit('cancel')
    }

    const handleOk = () => {
      const info = ref(toRaw(current.value))
      if (!info.value.song_name) {
        message.error('请选择歌曲上传')
        throw new Error('请选择歌曲上传')
      }
      if (info.value.para_info && info.value.para_info.length > 0) {
        info.value.para_info.forEach(item => {
          if (!item.name) {
            message.error('分段名不可为空')
            throw new Error('分段名不可为空')
          }
          if (item.start_time === undefined || item.start_time === null) {
            message.error('分段起始点不可为空')
            throw new Error('分段起始点不可为空')
          }
          if (!item.color) {
            message.error('分段点颜色不可为为空')
            throw new Error('分段点颜色不可为为空')
          }
        })
      }
      if (isEditComputed.value) {
        emit('onEditOk', info.value)
      } else {
        emit('onOk', info.value)
      }
      handleCancel()
    }

    return {
      formRef,
      labelCol,
      wrapperCol,
      visibleComputed,
      isEditComputed,
      current,
      colorList: ColorList,
      handleSelectSongOk,
      handleCancel,
      handleOk,
      handleDelete,
      handleAddParaInfo
    }
  }
}
